import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {purgeRecord} from "../services/CustomersService.ts";
import {useCustomersSelection} from "../hooks/useCustomersSelection.ts";
import {notifySuccess, notifyError} from "../../../components/ServiceNotifications";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useCustomersSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => purgeRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            notifySuccess('Customer purged');
            queryClient.invalidateQueries({queryKey: ['customers']});
        },
        onError: notifyError
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};